<template>
  <div style="margin: 0 auto; max-width: 800px;">
    <div class="mt-3 ml-5 mr-5" style="text-align: center;">
      <div v-if="this.error != ''">
        <v-alert type="error" v-bind="this.error" style="font-weight: bold;">{{this.error}}</v-alert>
      </div>

      <p class="mt-3 text-left link" @click="dashboard">Back to Dashboard</p>
      <h2>Address Book</h2>

      <v-btn
        class="mt-2 mb-2"
        style="box-shadow: 0 0 5px rgb(150, 150, 150);"
        height="50"
        color="success"
        @click="addNewAddress"
      >Add new address</v-btn>

      <v-row class="mt-3">
        <v-col
          v-for="address in this.addressBook"
          :key="address.address1"
          cols="12"
          sm="6"
          md="4"
          style="background-color: rgb(240,240,240); border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150); text-align: left;"
        >
          <p style="padding: 0px; margin: 0px;" v-if="address.default">
            <span style="font-weight: bold; color: #2196f3;">Default Address</span>
          </p>
          <p style="padding: 0px; margin: 0px;">
            <span style="font-weight: bold;">Name:</span>
            {{address.name}}
          </p>
          <p style="padding: 0px; margin: 0px;">
            <span style="font-weight: bold;">Address 1:</span>
            {{address.address1}}
          </p>
          <p style="padding: 0px; margin: 0px;">
            <span style="font-weight: bold;">Address 2:</span>
            {{address.address2}}
          </p>
          <p style="padding: 0px; margin: 0px;">
            <span style="font-weight: bold;">City:</span>
            {{address.city}}
          </p>
          <p style="padding: 0px; margin: 0px;">
            <span style="font-weight: bold;">State:</span>
            {{address.state}}
          </p>
          <p style="padding: 0px; margin: 0px;">
            <span style="font-weight: bold;">Zipcode:</span>
            {{address.zipcode}}
          </p>

          <div style="margin: 0 auto; text-align: center;">
            <v-btn
              class="mt-4 mr-1"
              style="box-shadow: 0 0 5px rgb(150, 150, 150); width: 40%;"
              color="info"
              @click="editAddress(address)"
            >Edit</v-btn>
            <v-btn
              class="mt-4 ml-1"
              style="box-shadow: 0 0 5px rgb(150, 150, 150); width: 40%;"
              color="error"
              @click="deleteAddress(address)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import AuthenticationService from "@/services/AuthenticationService";
import UserService from "@/services/UserService";

export default {
  data: () => ({
    error: "",
    addressBook: null,
    isErrorShake: false
  }),
  async mounted() {
    this.scrollToTop();
    try {
      const response = await AuthenticationService.dashboard();
      this.addressBook = this.$store.state.user.addressBook;
    } catch (error) {
      // Credentials failed. Logout user and instruct them to login
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.error = error.response.data.error;
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    home() {
      this.$router.push("/");
    },
    addNewAddress() {
      this.$router.push("/addNewAddress");
    },
    dashboard() {
      this.$router.push("/dashboard");
    },
    async deleteAddress(address) {
      let updatedAddressBook = [];
      this.addressBook.forEach(currentItem => {
        if (currentItem.address1 != address.address1) {
          updatedAddressBook.push(currentItem);
        }
      });
      this.addressBook = updatedAddressBook;
      this.$store.dispatch("setAddressBook", this.addressBook);
      try {
        const response = await UserService.updateAddressBook(
          this.$store.state.user.addressBook
        );
      } catch (error) {
        this.error = error.response.data.error;
      }
    },
    editAddress(address) {
      this.$store.dispatch("setShippingInfo", address);
      this.$router.push("/editAddress");
    }
  }
};
</script>

<style scoped>
.link {
  color: rgb(57, 93, 255);
  margin-bottom: 0px;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
